<small class="text-red-500">{{text | titlecase}}</small>